import type { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import type { IHttpClient } from 'utils/http/httpClient.model';

import type { CpOrderCancelResponse } from './model';

export interface CpOrderCancelApi {
  cancel(orderId: string): Observable<CpOrderCancelResponse>;
}

export function cpOrderCancelApiConnector(httpClient: IHttpClient): CpOrderCancelApi {
  return {
    cancel(orderId) {
      return httpClient
        .patch<CpOrderCancelResponse>({
          url: `api/v1/secondary-market/cp-order/cancel`,
          body: {
            orderId: orderId,
          },
          tryParseErrorPayload: true,
          targetHost: 'SecondaryBridge',
        })
        .pipe(map(({ payload }) => payload));
    },
  };
}
